import {
  MAX_USERNAME_LENGTH,
  MAX_USER_PASSWORD_LENGTH,
  MIN_USER_PASSWORD_LENGTH,
} from '@ipfabric/utils';

export const localUsersMessages = {
  en: {
    actionColumnTitle: 'Action',
    addButton: 'Add local user',
    newUserTitle: 'Create User',
    editUserTitle: 'Edit User: {username}',
    editCurrentUserTitle: 'Edit your own account',
    adminPassword: {
      error: 'You were signed out after entering an incorrect admin password.',
      title: 'Please sign in again.',
    },
    form: {
      createUserButton: 'Create user',
      updateUserButton: 'Update user profile',
      title: 'User Profile',
      updatePasswordTitle: 'Update Password',
      updatePasswordButton: 'Update Password',
      userCreated: 'User created',
      userUpdated: 'User updated',
      passwordUpdated: 'Password updated',
      fields: {
        username: 'Username',
        timezone: 'Timezone',
        roleIds: 'Roles',
        password: 'Password',
        newPassword: 'New password',
        retypePassword: 'Retype password',
        adminPassword: 'Enter your admin password',
        adminPasswordDescription:
          'Enter your own admin password to authorize the password change.',
      },
      validations: {
        required: 'Required',
        usernameNotAllowedCharacters:
          'Username can contain only letters, numbers and _-.@',
        usernameMaxLength: `Username must have at most ${MAX_USERNAME_LENGTH} characters`,
        passwordMinLength: `Password must have at least ${MIN_USER_PASSWORD_LENGTH} characters`,
        passwordMaxLength: `Password must have at most ${MAX_USER_PASSWORD_LENGTH} characters`,
        passwordComplexity: 'Password must follow these requirements',
        matchPasswords: 'Passwords do not match',
      },
      passwordChangeInfo: `Changing the password will log the user out of all active sessions. \n
        Entering an incorrect admin password will sign you out for security reasons.`,
    },
    confirmDeleteUser: {
      header: 'User will be deleted',
      subHeader: 'Do you really want to delete the user?',
    },
  },
};
